import { render, staticRenderFns } from "./sub-header.vue?vue&type=template&id=c89530ec"
import script from "./sub-header.vue?vue&type=script&lang=js"
export * from "./sub-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports